import React from 'react'

const ValidationErrorText = ({ text, extraClass }) => {
    return <p className={`text-danger text-sm mb-0 mt-1 commonError ${extraClass}`}>{text}</p>;
  };

export default ValidationErrorText
